import React, { Suspense, useState, useEffect, useRef } from "react";
import { Modal } from 'react-responsive-modal';
import TransactionServices from "../TransactionServices";

export default function ViewUploadFileLogBox(param: any) {
    console.log(param)

    const [openFirst, setOpenFirst] = useState(false);

    const returnValue = (e: any) => {
        param.onChange(e)
        setOpenFirst(false)
    }

    let [youtubeUploadFileLog, setYoutubeUploadFileLog] = useState<any[]>([]);
    const youtubeViewUpload = () => {
        var payload = { pageNumber: 1, pageSize: 10, source: 'none' }
        TransactionServices.viewYTUploadFileLog(payload).then((res) => {
            console.log(res)
            youtubeUploadFileLog = res
            setYoutubeUploadFileLog(res)
            console.log("youtube")
        })
    }

    let [youtubeRedUploadFileLog, setYoutubeRedUploadFileLog] = useState<any[]>([]);
    const youtubeRedViewUpload = () => {
        var payload = { pageNumber: 1, pageSize: 10, source: 'none' }
        TransactionServices.viewYRUploadFileLog(payload).then((res) => {
            console.log(res)
            youtubeRedUploadFileLog = res
            setYoutubeRedUploadFileLog(res)
            console.log("youtube red")
        })
    }

    let [amazonUploadFileLog, setAmazonUploadFileLog] = useState<any[]>([]);
    const amazonViewUpload = () => {
        var payload = { pageNumber: 1, pageSize: 10, source: 'none' }
        TransactionServices.viewAZUploadFileLog(payload).then((res) => {
            console.log(res)
            amazonUploadFileLog = res
            setAmazonUploadFileLog(res)
            console.log("amazon")
        })
    }

    let [googlePlayUploadFileLog, setGooglePlayUploadFileLog] = useState<any[]>([]);
    const googlePlayViewUpload = () => {
        var payload = { pageNumber: 1, pageSize: 10, source: 'none' }
        TransactionServices.viewGPUploadFileLog(payload).then((res) => {
            console.log(res)
            googlePlayUploadFileLog = res
            setGooglePlayUploadFileLog(res)
            console.log("google play test")
        })
    }

    let [spotifyUploadFileLog, setSpotifyUploadFileLog] = useState<any[]>([]);
    const spotifyViewUpload = () => {
        var payload = { pageNumber: 1, pageSize: 10, source: 'none' }
        TransactionServices.viewSPUploadFileLog(payload).then((res) => {
            console.log(res)
            spotifyUploadFileLog = res
            setSpotifyUploadFileLog(res)
            console.log("spotify test")
        })
    }

    useEffect(() => {
        youtubeViewUpload()
        youtubeRedViewUpload()
        amazonViewUpload()
        googlePlayViewUpload()
        spotifyViewUpload()
    }, [param.param])

     const onClose = () => {
        param.ViewUploadFileLogClose();
    }


    return (
        <div className="ws-6">
            <Modal open={param.param} onClose={onClose} styles={{ modalContainer: { background: 'transparent !important', width: "50% !important" } }} center classNames={{ overlay: '', modal: 'ws-5 paddingCenterBox bgTransparent' }} >
                <div className="row-fluid sortable box">

                    <div className="modal-header">
                        <div className="box-header-main">
                            <h2 className="ws-10 ">View Upload File Log</h2>
                            <div className="toolbox">
                                <button title="Reload Upload File Log" className="btn icon-btn delete pull-right" data-ng-click="init()"><i className="icon-refresh1"></i> Refresh</button>
                            </div>
                        </div>
                    </div>

                    <div className="box-content">
                        <div className="form-horizontal  form-condensed clearfix">
                            <div className="row-fluid">
                                <div className="form-format ws-12">
                                    <div className="ws-4">
                                        <label className="control-label ">Filename</label>
                                        <div className="label-entries ws-12">
                                            <input type="text" className="form-control pLarge ws-12 " placeholder="Enter Filename" ng-model="filename" id="filename"/>
                                        </div>
                                    </div>

                                    <div className="ws-1 mt">
                                        <button className="btn icon-btn edit mtl " data-ng-click="getFileLogListing(filename)"><i className="fa fa-search"></i>Search </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row-fluid sortable" ng-show="filelogCount != null">
                        <div className="box span12">
                            <div className="box-header well">
                                <h2> <i className="fa fa-table"></i> <span ng-bind="filelogCount + ' ' + 'record(s) found'" >0 record(s) found</span>  </h2>
                            </div>
                            <div className="box-content">
                                <div className="alert alert-info " data-ng-show="filelogCount == 0"> No records to display</div>
                                <div className="table-responsive">
                                    <table className="table ng-hide" data-ng-show="filelogCount &gt; 0">
                                        <thead>
                                            <tr>
                                                <th >File</th>
                                                <th >Status</th>
                                                
                                                <th >Date</th>
                                                <th >Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            
                                        </tbody>
                                    </table>
                                </div>
                                <div className="clearfix">

                                    <ul className="pull-left m0 mt pagination ng-isolate-scope ng-valid ng-hide" data-items-per-page="filelogItemsPerPage" total-items="filelogCount" ng-model="filelogCurrentPage" max-size="3" ng-change="changeFileLogListing(filename, filelogCurrentPage, filelogItemsPerPage)" data-ng-show="filelogCount &gt; 10">
                                        <li ng-if="::directionLinks" ng-className="{disabled: noPrevious()||ngDisabled}" className=" disabled"><a href="" ng-click="selectPage(page - 1, $event)" >Previous</a></li>
                                       <li ng-repeat="page in pages track by $index" ng-className="{active: page.active,disabled: ngDisabled&amp;&amp;!page.active}" className=" active"><a href="" ng-click="selectPage(page.number, $event)" >1</a></li>
                                        <li ng-if="::directionLinks" ng-className="{disabled: noNext()||ngDisabled}" className=" disabled"><a href="" ng-click="selectPage(page + 1, $event)" >Next</a></li>
                                        
                                    </ul>
                                    <div className="page-size-control mt">
                                        <select title="Items per page" data-ng-options="item as item for item in pageSizes" data-ng-change="filelogCurrentPage=1; changeFileLogListing(filename, filelogCurrentPage, filelogItemsPerPage)" data-ng-model="filelogItemsPerPage" data-ng-show="filelogCount &gt; 10" className=" ng-hide"><option value="0" selected label="10">10</option><option value="1" label="20">20</option><option value="2" label="50">50</option><option value="3" label="100">100</option></select>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                    <div className="box-footer">
                        <button className="btn icon-btn delete pull-right " onClick={onClose}><i className="fa fa-close"></i>Close</button>
                    </div>

                </div>
            </Modal>
        </div>
    )
}